import api from './api';

export interface ThumbnailGenerationRequest {
  title?: string;
  description?: string;
  videoS3Key?: string;
  videoS3Url?: string;
  transcript?: string;
  brandKit?: {
    primaryColor?: string;
    secondaryColor?: string;
    font?: string;
    logoS3Key?: string;
  };
  targetDimension?: { width: number; height: number };
}

export interface IGeneratedThumbnail {
  thumbnailId: string;
  s3Key?: string;
  s3Url?: string;
  rank: number;
  ctrScore: number;
  layout: string;
  textOverlay: string;
  timestamp: number;
  metadata?: {
    brightness?: number;
    contrast?: number;
    sharpness?: number;
    entropy?: number;
  };
}

export interface IThumbnailGenerationJob {
  jobId: string;
  title?: string;
  status: 'queued' | 'processing' | 'completed' | 'failed' | 'cancelled';
  progress: number;
  currentStep: string;
  error?: string;
  topThumbnails: IGeneratedThumbnail[];
  createdAt: string;
  updatedAt: string;
}

export const thumbnailGenerationApi = {
  createJob: (request: ThumbnailGenerationRequest) =>
    api.post<{ success: boolean; jobId: string; status: string }>('/thumbnail-generation', request),

  getJob: (jobId: string) =>
    api.get<{ success: boolean; job: IThumbnailGenerationJob }>(`/thumbnail-generation/${jobId}`),

  getJobs: () =>
    api.get<{ success: boolean; jobs: IThumbnailGenerationJob[] }>('/thumbnail-generation'),

  getThumbnailSignedUrl: (jobId: string, thumbnailId: string) =>
    api.get<{ success: boolean; url: string }>(
      `/thumbnail-generation/${jobId}/thumbnails/${thumbnailId}/url`
    ),

  deleteJob: (jobId: string) =>
    api.delete<{ success: boolean; message: string }>(`/thumbnail-generation/${jobId}`),

  updateThumbnailText: (jobId: string, thumbnailId: string, textOverlay: string) =>
    api.patch<{ success: boolean; thumbnail: IGeneratedThumbnail }>(
      `/thumbnail-generation/${jobId}/top-thumbnails/${thumbnailId}`,
      { textOverlay }
    ),
};
